import { P2GBox, P2GContainer, P2GFade } from '@parcel2go/core-ui';
import { Suspense } from 'react';

export const OnboardingScreenWrapper = ({
  children,
  progress
}: {
  children: React.ReactNode;
  progress: React.ReactNode;
}) => {
  return (
    <P2GBox textAlign="center" sx={{ pt: { xs: '10px', sm: '30px' } }}>
      <P2GContainer>{progress}</P2GContainer>
      <P2GFade in timeout={1500}>
        <Suspense>
          <P2GBox textAlign="center" sx={{ pt: { xs: '20px', sm: '40px' } }}>
            {children}
          </P2GBox>
        </Suspense>
      </P2GFade>
    </P2GBox>
  );
};
